import { Directive, HostListener, Output, Input, EventEmitter, ElementRef, OnInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';

@Directive({
    selector: '[appScrollSpy]'
})
export class ScrollSpyDirective implements OnInit, OnDestroy {
    @Input() public spiedTags = [];
    @Input() public scrollOffset = 0;
    @Input() public local = false;
    @Output() public sectionChange = new EventEmitter<string>();
    private currentSection: string;

    constructor(private _el: ElementRef) { }

    ngOnInit() {
        $(document).on('scroll', (event) => this.onScroll(event));
    }

    ngOnDestroy() {
        $(document).off('scroll', (event) => this.onScroll(event));
    }

    @HostListener('scroll', ['$event'])
    onScroll(event: any) {
        let currentSection: string;
        const children = this._el.nativeElement.children;
        let scrollTop: number;
        if (this.local)
            scrollTop = this._el.nativeElement.scrollTop;
        else
            scrollTop = $('html').scrollTop();
        const parentOffset = this.scrollOffset;
        if(children.length>0){
            if(children[0].className=="section-wrapper") return
            //console.log("sbe2",children[0].offsetTop,parentOffset,children) 
            let firstOffset = children[0].offsetTop
            for (let i = 0; i < children.length; i++) {
                const element = children[i];
                if (this.spiedTags.some(spiedTag => spiedTag === element.tagName)) {
                    if ((element.offsetTop - firstOffset) <= parentOffset) {
                        currentSection = element.id;
                    }
                }
            }
        
            if (currentSection && currentSection !== this.currentSection) {
                this.currentSection = currentSection;
                this.sectionChange.emit(this.currentSection);
            }
        }    
    }
}


// WEBPACK FOOTER //
// ./src/app/directive/scroll-spy.directive.ts